import React from 'react';
import {render} from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {Provider} from 'react-redux';
import store from "./redux/store";
import {ToastContainer} from "react-toastify";

const rootElement = document.getElementById("root");

render(
    <BrowserRouter>
        <Provider store={store}>
            <App/>
            <ToastContainer position={"bottom-center"}/>
        </Provider>
    </BrowserRouter>, rootElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
